//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    RAW_DATA_GET_DEVICE_READING_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    getDeviceReadingResult
} from 'Redux/actions';

function* getDeviceReadingJSON({ payload }) {
    try {
        let QUERY = `
            query getDeviceReadingJSON ($id: String!, $deviceId: String!) {
                result: getDeviceReadingJSON (id: $id, deviceId: $deviceId)
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        
        yield put(getDeviceReadingResult(data?.result))

    } catch (exc) {
        yield put(getDeviceReadingResult(null))
        ExceptionManager(exc, 'Modules/rawData/.components/tab/.components/details/redux/saga', 'getDeviceReadingJSON');
    }
}
function* watchCatalogRequests() {
    yield takeEvery(RAW_DATA_GET_DEVICE_READING_REQUEST, getDeviceReadingJSON);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchCatalogRequests)
    ]);
}